module.exports = __webpack_public_path__ + "img/door-contact-lg-unlocked.fae8e9ce.svg";